import { render, staticRenderFns } from "./MultipleDatesHolidaysCraete.vue?vue&type=template&id=61221662&scoped=true&"
import script from "./MultipleDatesHolidaysCraete.vue?vue&type=script&lang=js&"
export * from "./MultipleDatesHolidaysCraete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61221662",
  null
  
)

export default component.exports